export default "__VITE_ASSET__Ctm0lg$k__"